module.exports = __webpack_public_path__ + "static/pink-rectangle-ad83e9ae1fecad8a49428383f714c8e0.webp";